import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { PageHeader } from "@/widgets/page-header";
import {
    selectWhitelistedPhones,
    selectWhitelistedPhonesLoading,
    selectWhitelistedPhonesFirstLoad,
    fetchWhitelistedPhones,
    fetchDeleteWhitelistEntry,
} from "../model";
import { PhoneWhitelistTable } from "./phone-whitelist-table";
import { WhitelistToggle } from "./whitelist-toggle";
import { AddPhoneForm } from "./add-phone-form";
import { BulkImport } from "./bulk-import";
import notify from "@/shared/lib/notify";
import { getErrorMessage } from "@/shared/consts/error-codes";

export const PhoneWhitelistPage = () => {
    const dispatch = useAppDispatch();
    const phones = useAppSelector(selectWhitelistedPhones);
    const isLoading = useAppSelector(selectWhitelistedPhonesLoading);
    const isFirstLoad = useAppSelector(selectWhitelistedPhonesFirstLoad);

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchWhitelistedPhones());
        }
    }, [dispatch, isFirstLoad]);

    const handleDelete = async (id: string) => {
        try {
            await dispatch(fetchDeleteWhitelistEntry(id)).unwrap();
            notify.success('Телефон успешно удален из белого списка');
            dispatch(fetchWhitelistedPhones());
        } catch (error: any) {
            notify.error(getErrorMessage(error));
        }
    };

    return (
        <div className="_page_container">
            <PageHeader title="Белый список телефонов" />
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                    <WhitelistToggle />
                </div>
                <div className="col-span-12 lg:col-span-6">
                    <AddPhoneForm />
                </div>
                <div className="col-span-12 lg:col-span-6">
                    <BulkImport />
                </div>
                <div className="col-span-12">
                    <PhoneWhitelistTable
                        phones={phones}
                        isLoading={isLoading}
                        onDelete={handleDelete}
                    />
                </div>
            </div>
        </div>
    );
};

